// eslint-disable-next-line import/prefer-default-export
export const manageSession = () => {
  Object.keys(sessionStorage)
    .forEach(key => localStorage.setItem(key, sessionStorage.getItem(key)));
  return true;
};
// eslint-disable-next-line import/prefer-default-export
export const retriveSession = () => {
  Object.keys(localStorage)
    .forEach(key => sessionStorage.setItem(key, localStorage.getItem(key)));
  localStorage.clear();
};
export const geoUpdateHandler = callback => (event) => {
  if (!event.newValue) return;
  if (event.key === 'geoUpdated') {
    // another tab asked for the sessionStorage -> send it
    // eslint-disable-next-line radix
    callback(parseInt(localStorage.getItem('geoUpdated')));
    // the other tab should now have it, so we're done with it.
    localStorage.removeItem('geoUpdated'); // <- could do short timeout as well.
  }
};
export const geoUpdateHandlerEditRoutes = callback => (event) => {
  if (!event.newValue) return;
  if (event.key === 'geoUpdated') {
    // another tab asked for the sessionStorage -> send it
    // eslint-disable-next-line radix
    callback(parseInt(localStorage.getItem('geoUpdated')));
    // the other tab should now have it, so we're done with it.
    localStorage.removeItem('geoUpdated'); // <- could do short timeout as well.
  }
};
